import { createBrowserHistory } from 'history';

import createRootReducer from 'taker/reducers';

import createStore from '../createStore';

export default createStore(createRootReducer, createBrowserHistory());
